import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Tile from "@amzn/meridian/esm/components/tile";
import { THEME_COLOR } from "../../styles/colors";
import { pulseClass } from "../../styles/motion";

/**
 * Loading placeholder matching the prototype: three horizontal shimmer bars inside a Tile, simulating
 * text lines. No avatar circle — the bars alone communicate "content is loading" without committing
 * to a layout the real card may not match exactly.
 */
const SkeletonCard = () => (
  <Tile accent={THEME_COLOR.MIST_GRAY} accentPosition="start" spacingInset="400">
    <Column spacing="300">
      <Box className={pulseClass(0)} type="fill" width="60%" height="14px" />
      <Box className={pulseClass(120)} type="fill" width="80%" height="12px" />
      <Box className={pulseClass(240)} type="fill" width="40%" height="12px" />
    </Column>
  </Tile>
);

export default SkeletonCard;
